module.exports = __webpack_public_path__ + "static/media/Healthcare_Hero_01.7fc0c892.jpg";